import PageHero from '@/components/feature/PageHero';

export default function ArchitectureHero() {
  return (
    <PageHero
      eyebrow="九畴云铺 · 产品架构"
      title="五层平台架构"
      titleHighlight="用户 · 场景 · 交易 · 基础设施 · 治理"
      desc="九畴云铺不只是一个前端商城，而是一套完整的平台治理系统。五层架构自下而上，从用户生态到业务场景、交易权益、数字基础设施，再到平台治理，逐层清晰呈现。"
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20layered%20platform%20architecture%20visualization%2C%20deep%20dark%20ink%20navy%20background%2C%20five%20horizontal%20translucent%20layers%20with%20glowing%20emerald%20and%20gold%20connection%20nodes%2C%20digital%20commerce%20ecosystem%2C%20futuristic%20rural%20digital%20economy%2C%20minimal%20clean%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=jiuchou-layer-01&orientation=landscape"
      imageAlt="九畴云铺 五层平台架构"
      imageTitle="九畴云铺 五层平台架构"
    />
  );
}